<template>
    <div class="contx">
        <div class="imgbg" style="text-align: center">
            <img src="../img/qx.png" alt="">
            <p>对不起<br>您当前尚不满足成为代理人的条件</p>
        </div>
        <div class="cont_x">
            <div class="cont_x_fenx">
                <img src="../img/bian.png" alt="">
                <h3>成为代理人需满足以下条件：
                </h3>
            </div>
            <div class="guize">
                <p  v-for="(item,i)  in fail" :key="i">
                    <span v-if="item">{{ (i+1) }}、{{ item }}</span>
                </p>
            </div>
        </div>
        <div>
            <button @click="btn()">去完成</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fail",
        data() {
            return {
                fail: null,
                channelType:""
            }
        },
        computed: {},
        components: {},
        filters: {},
        created() {
            console.log('this.route',this.$route)
            if (this.$route.query.fail) {
                this.fail = this.$route.query.fail;
                this.fail = this.fail.split("。")
                console.log('this.route',this.fail)
            }
            this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
        },
        methods: {
            btn(){
                // window.history.back();
                window.location.replace('/distribution/goodsHome')
            }
        }
    }
</script>

<style scoped>
    .contx {
        padding-top: 64px;
        background: #fff;
        height: 100vh;
        box-sizing: border-box;
    }

    .imgbg img {
        width: 194px;
        height: 160px;
        margin-bottom: 60px;
    }

    .imgbg p {
        font-size:30px;
        font-weight:500;
        color:rgba(64,64,64,1);
        line-height:44px;
        padding-bottom: 60px;
        border-bottom: 1px solid #E6E6E6;
    }
    .cont_x{
        padding-top: 58px;
    }
    .cont_x_fenx {
        display: flex;
        align-items: center;
    }

    .cont_x_fenx h3 {
        font-size: 28px;
        font-weight: 500;
        color: rgba(64, 64, 64, 1);
        margin-left: 30px;
        margin-right: 20px;
    }

    .cont_x_fenx p {
        font-size: 24px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
    }

    .cont_x img {
        width: 6px;
        height: 32px;
    }

    .guize{
        padding:16px 30px;
        color: #999;
    }

    button{
        width:560px;
        height:90px;
        border-radius:45px;
        border:2px solid rgba(221,43,30,1);
        background: #fff;
        font-size:36px;
        font-weight:400;
        color:rgba(221,43,30,1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        margin-top: 120px;
    }

</style>
